<template>
  <v-container container--fluid fluid pt-0
    :style="formContainerStyle"
  >
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown && hasEditAccess"
      :loading="saving"
      :disabled="!!subtableFormOpenForModule"
      :dark="!subtableFormOpenForModule"
      @click="saveFormData"
      fixed
      bottom
      right
      top
      :color="saveBtnColor"
      fab
      :style="floatingSaveButtonStyle"
      :x-small="appBarIsDense"
      :small="!appBarIsDense"
    >
      <v-icon small>fa-save</v-icon>
    </v-btn>
    <div style="position: relative;">
      <!-- div v-if="!subtableFormOpenForModule" :style="helperBackgroundFix">
        {{ level }}
      </div -->

      <v-app-bar
        :color="appBarColor"
        :flat="limitedAppBar || level === 0"
        :style="appBarStyle"
        class="form-app-bar elevation-1"
        :height="appBarIsDense ? 40 : 60"
      >

        <v-btn
          @click="backToList"
          icon
          :small="appBarIsDense"
          color="grey darken-2"
        >
          <v-icon
            small
          >
            {{ level > 0 ? 'fa-chevron-left' : 'fa-list-ul' }}
          </v-icon>
        </v-btn>

        <template v-if="formTitle && (appBarIsDense || !$vuetify.breakpoint.smAndDown)">
          <v-toolbar-title
            :class="'form-title ' + (appBarIsDense ? 'dense-bar' : '')"
          >
            {{ formTitle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title
            :class="'form-module-name ' + (appBarIsDense ? 'dense-bar' : '')"
          >
            {{ formModuleName }}
          </v-toolbar-title>
        </template>
        <template v-else>
          <v-spacer></v-spacer>
          <v-row no-gutters >
            <v-col cols="12" class="pa-0 form-title-selected"
              :style="selectedFormTitleStyle"
            >
              {{ formTitle }}
            </v-col>
            <v-col cols="12"
              :class="'pa-0 ' + (!formTitle ? 'form-title-selected' : 'form-module-name-selected')"
            >
              {{ formModuleName }}
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </template>




        <div
          v-if="!loading && !limitedAppBar"
          :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 20px;'  : ''"
        >
          <v-btn
            v-if="!$vuetify.breakpoint.smAndDown && hasEditAccess"
            :loading="saving"
            :disabled="!!subtableFormOpenForModule"
            :dark="!subtableFormOpenForModule"
            @click="saveFormData"
            :color="saveBtnColor"
            fab
            :x-small="appBarIsDense"
            :small="!appBarIsDense"
            class="elevation-0"
          >
            <v-icon small>fa-save</v-icon>
          </v-btn>

          <template
              v-if="pdfTemplates.length > 0"
          >
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                    color="primary"
                    dark
                    v-on="on"
                    icon
                    class="mx-3"
                >
                  <v-icon>fa-file-pdf</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                    v-for="(pdfTemplate, index) in pdfTemplates"
                    :key="index"
                    @click.stop="getPdf(pdfTemplate, data, this.lang)"
                    class="text-right"
                >
                  <v-list-item-title>
                    {{ pdfTemplate.name }}
                    <v-btn
                        v-for="(lang, li) in contentLanguages"
                        :key="li"
                        fab
                        x-small
                        :text="!(data && (data.lang === lang.code || data.language === lang.code))"
                        :outlined="data && (data.lang === lang.code || data.language === lang.code)"
                        class="ml-2 elevation-0"
                        @click.stop="getPdf(pdfTemplate, data, lang.code)"
                    >
                      {{ lang.code }}
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <v-menu
            v-if="id !== '0'"
            left
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" style="margin-right: -10px;">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-if="hasDeleteAccess && !deleteStarted && id !== '0'"
                @click="startDeleteItem"
              >
                <v-list-item-title>
                  Delete <v-icon small>fa-trash</v-icon>
                </v-list-item-title>
              </v-list-item>
              <!--
                duplicate
                print ?
                change history
              -->
            </v-list>
          </v-menu>

          <!-- v-btn
            v-if="hasDeleteAccess && !deleteStarted && id !== '0'"
            @click="startDeleteItem"
            :disabled="!!subtableFormOpenForModule"
            icon
            color="warning"
          >
            <v-icon small>fa-trash</v-icon>
          </v-btn>
          <v-btn
            v-else-if="hasDeleteAccess && id !== '0'"
            :disabled="!!subtableFormOpenForModule"
            @click="deleteItem" icon color="error"
            style="margin-right: 70px;"
          >
            <v-icon small>fa-trash</v-icon>
          </v-btn -->
        </div>

        <template
          v-if="!subtableFormOpenForModule && module.tabs && Object.keys(module.tabs).length > 0"
          v-slot:extension
        >
          <v-tabs
            v-model="selectedTab"
            fixed-tabs
            show-arrows
            :class="subtableFormOpenForModule ? 'hide-tabs' : ''"
          >
            <v-tab
              v-for="tabKey in Object.keys(module.tabs)"
              :key="tabKey"
            >
              {{ module.tabs[tabKey]['tabNameText_' + language] || module.tabs[tabKey]['tabNameText_en'] }}
            </v-tab>
          </v-tabs>
        </template>

      </v-app-bar>

      <v-row v-if="loading">
        <v-col cols="12">
          <v-progress-circular
            :width="3"
            color="green"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
      <form v-if="!loading">
        <v-row wrap
          :dense="cs.formDense || ($vuetify.breakpoint.smAndDown && cs.formDenseMobile)"
          class="elevation-0"
          :style="formFieldsContainer"
        >
          <v-col
            cols="12"
            class="pa-0 elevation-0"
            v-if="module.tabs && Object.keys(module.tabs).length > 0"
          >
            <v-tabs-items
              v-if="module.tabs && Object.keys(module.tabs).length > 0"
              v-model="selectedTab"
              touchless
            >
              <v-tab-item
                v-for="tabKey in Object.keys(module.tabs)"
                :key="tabKey + 'item'"
                :style="formTabStyle"
              >
                <v-container fluid>
                  <v-row wrap mt-4>
                    <module-form-field
                      v-for="(field, index) in visibleFormFields"
                      :key="index"
                      v-model="data"
                      :field="field"
                      :parent-module="parentModule"
                      :parent-id="parentId"
                      :id="id"
                      :module-name="moduleName"
                      :link-options="linkOptions"
                      :save-form-data="saveFormData"
                      :tab="tabKey"
                      :set-subtable-form-open-module="setSubtableFormOpenModule"
                      :subtable-form-open-for-module="subtableFormOpenForModule"
                      :level="level"
                      :display-none="displayNone(field)"
                    />
                  </v-row>
                </v-container>
                <module-calendar
                  v-if="module.tabs[tabKey].component === 'calendar'"
                  :parent-object="data"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-col>

          <template
            v-if="!module.tabs || Object.keys(module.tabs).length === 0"
          >
            <module-form-field
              v-for="(field, index) in visibleFormFields"
              :key="index"
              v-model="data"
              :field="field"
              :parent-module="parentModule"
              :parent-id="parentId"
              :id="id"
              :module-name="moduleName"
              :link-options="linkOptions"
              :save-form-data="saveFormData"
              :set-subtable-form-open-module="setSubtableFormOpenModule"
              :subtable-form-open-for-module="subtableFormOpenForModule"
              :level="level"
              :display-none="displayNone(field)"
            />
          </template>
        </v-row>
      </form>
      <!-- template v-if="!loading">
        <v-btn @click="saveFormData">save</v-btn>
        <v-btn @click="backToList">list</v-btn>
        <v-btn @click="deleteItem" color="error">delete</v-btn>
      </template -->
    </div>
  </v-container>
</template>

<script>
import ModuleFormField from './ModuleFormField'
import sharedComputed from './../computed'
import sharedMethods from './../methods'
import api from './../../api'
import ModuleCalendar from './ModuleCalendar'

export default {
  name: 'ModuleForm',

  components: {
    ModuleFormField,
    ModuleCalendar
  },

  data () {
    return {
      selectedTab: null,
      module: {},
      data: {},
      loading: true,
      saving: false,
      linkOptions: {},
      supportingData: {},
      deleteStarted: false,
      subtableFormOpenForModule: null,
      formDataAtOpen: {},
      lastSaveTimestamp: 0
    }
  },

  props: {
    moduleName: {
      type: String,
      default: null
    },

    parentModule: {
      type: String,
      default: null
    },

    parentId: {
      type: String,
      default: null
    },

    id: {
      type: String,
      default: null
    },

    callbackOnChange: {
      type: Function,
      default: () => {}
    },

    level: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...sharedComputed,

    pdfTemplates () {
      return this.$store.getters.pdfTemplatesByModule && this.$store.getters.pdfTemplatesByModule[this.moduleName] || []
    },

    formDataIsChanged () {
      const dataIsChanged = JSON.stringify(this.data) !== JSON.stringify(this.formDataAtOpen)
      return dataIsChanged
    },

    saveBtnColor () {
      if (this.formDataIsChanged) {
        return 'red lighten-1'
      } else if (this.formIsJustNowSaved) {
        return 'green lighten-1'
      }
      return 'grey lighten-1'
    },

    formIsJustNowSaved () {
      return (+new Date() - this.lastSaveTimestamp) < 2000
      // This check for 2000 does not matter actually as reactivity does not work here
      // instead have setTimeout to change lastSaveTimestamp = 0
    },

    limitedAppBar () {
      return !!this.subtableFormOpenForModule
    },

    selectedFormTitleStyle () {
      return {
        maxWidth: (this.innerWidth - 130) + 'px'
      }
    },

    floatingSaveButtonStyle () {
      return {
        top: (this.innerHeight - 60) + 'px'
      }
    },

    visibleFormFields () {
      return this.fieldsArrayFromModule
        .filter(field => {
          let show = true
          if (field.info.formHide) { show = false }
          return show
        })
    },

    appBarColor () {
      let step = 10
      let colorCode = 245 - this.level * step
      return 'rgb(' + colorCode + ', ' + colorCode + ', ' + colorCode + ')'
    },

    formFieldsContainer () {
      let style = {}
      if (this.level === 0) {
        // style.marginTop = '10px'
      }
      return style
    },

    appBarTopffset () {
      return ((this.level * (this.formAppBarHeightDense) - this.formAppBarHeightDense) +
        this.formAppBarHeight
      )
    },

    helperBackgroundFix () {
      // TODO later
      // let padding = 10
      // let padding2 = 8
      // let height = this.level * (this.formAppBarHeightDense) + this.formAppBarHeight + padding * 2
      // if (this.module.tabs && Object.keys(this.module.tabs).length > 0) {
      //   height = height + 48
      // }
      // console.log('height', height)
      // return {
      //   position: 'sticky',
      //   background: 'red',
      //   width: '120%',
      //   zIndex: 1,
      //   opacity: 0.3,
      //   top: (this.toolbarHeight - this.appBarTopffset + this.formAppBarHeight + padding + padding2) + 'px',
      //   left: 0,
      //   marginTop: '-' + (height) + 'px',
      //   marginBottom: '-' + (height) + 'px',
      //   height: height + 'px'
      // }
    },

    appBarTopffset () {
      let topOffset = (
        0 +
        (this.level * (this.formAppBarHeightDense))
      )
      if (!this.$vuetify.breakpoint.smAndDown) {
        // topOffset += 20
      }
      return topOffset
    },

    appBarStyle () {
      let style = {
        borderBottom: this.limitedAppBar
          ? '1px solid #ccc'
          : '',
        top: (this.appBarTopffset) + 'px',
        marginBottom: this.limitedAppBar
          ? ''
          : '20px'
      }
      return style
    },

    appBarIsDense () {
      return this.limitedAppBar
    },

    computedId () {
      return this.id
    },

    formTitle () {
      if (this.module.titleField && (this.data[this.module.titleField] || this.data[this.module.titleField + '_' + this.language])) {
        return this.data[this.module.titleField] || this.data[this.module.titleField + '_' + this.language]
      }
      return ''
    },

    formModuleName () {
      return this.module['nameSingular_' + this.language] || this.module.nameSingular_en || this.module.singular || this.module.moduleName
    },

    hasEditAccess () {
      return this.$store.getters.ac.can('current').updateAny(this.moduleName).granted ||
        this.$store.getters.ac.can('current').updateOwn(this.moduleName).granted
    },

    hasDeleteAccess () {
      return this.$store.getters.ac.can('current').deleteAny(this.moduleName).granted ||
        this.$store.getters.ac.can('current').deleteOwn(this.moduleName).granted
    },

    formContainerStyle () {
      if (this.parentModule) { // || this.module.tabs
        return {
          // position: 'relative'
        }
      }
      const levelOffset = this.level * this.formAppBarHeight
      let height = (this.innerHeight - 100 - levelOffset)
      if (this.cs.noDesktopGutters) {
        height += 27
      }
      let style = {
        overflow: 'auto',
        width: '100%',
        height: height + 'px',
        paddingTop: 0 + 'px',
        marginTop: (this.$vuetify.breakpoint.smAndDown || this.cs.noDesktopGutters ? 0 : 10) + 'px',
        background: 'white'
      }
      return style
    },

    formTabStyle () {
      return {}
      // if (this.parentModule) {
      //   return {}
      // }
      // return {
      //   overflow: 'auto',
      //   width: '100%',
      //   height: (this.innerHeight - 260) + 'px',
      //   background: 'white'
      // }
    },

    moduleNameAndIdAndParent () {
      return this.moduleName + '_' + this.id + '_' + (
        this.parentModuleName || ''
      ) + '_' + (
        this.parentObjectId || ''
      )
    }
  },

  watch: {
    id (before, value) {
      // change of id and value
      //if (before && value) {
      //  this.init()
      //}
    },

    moduleNameAndIdAndParent (value) {
      if (value) {
        if (this.modules[this.moduleName]) {
          this.module = this.modules[this.moduleName]
          // this.openList()
          // module has changed and form is still open?
          // > call init
          this.init()
        } else {
          this.module = {}
        }
      }
    }
  },

  created () {
    this.init()
  },

  methods: {
    ...sharedMethods,

    displayNone (field) {
      return !(!this.subtableFormOpenForModule || (
        this.subtableFormOpenForModule === field.fieldName
      ))
    },

    setSubtableFormOpenModule (forModule) {
      this.subtableFormOpenForModule = forModule
    },

    init () {
      this.loading = true
      this.deleteStarted = false
      this.data = {}
      if (this.modules[this.moduleName]) {
        this.module = this.modules[this.moduleName]
      }
      if (this.id !== '') {
        api.getOneItem(this.apiUrl, this.moduleName, this.id).then((data) => {
          this.applyDefaultValues(data)
          this.$store.dispatch('getLinkFieldOptions', this.moduleName).then((result) => {
            this.updateLinkOptions()
            this.updatePopulatedFieldLinksAndSetReactiveFields(data)
            this.data = data
            if (this.id !== '0') {
              this.formDataAtOpen = JSON.parse(JSON.stringify(data))
            }
            this.setDefaultValues()
            this.loading = false
          })
        })
      }
    },

    updatePopulatedFieldLinksAndSetReactiveFields (data) {
      Object.keys(this.module.fields).forEach((fieldName) => {
        if (['Link'].includes(this.module.fields[fieldName].type)) {
          // change populated arrays as _id instaed, for dropdow
          if (data[fieldName]) {
            // But add also add valuePopulated as this is useful elsewhere
            data[fieldName + 'Populated'] = data[fieldName]
            // And then id for link field, this changed by autocomplete by v-model
            data[fieldName] = data[fieldName]._id
          } else {
            data[fieldName] = null
          }
        } else if (this.module.fields[fieldName].type === 'Denormalized' && !data[fieldName]) {
          data[fieldName] = []
        } else if (this.module.fields[fieldName].type === 'FeaturesByGroup' && !data[fieldName]) {
          data[fieldName] = {}
        } else if (!(fieldName in data)) {
          data[fieldName] = null // Must set a property to be reactive
        }
      })
    },

    applyDefaultValues (data) {
      if (this.id !== '0') { return }
      Object.keys(this.module.fields).forEach((fieldName) => {
        const field = this.module.fields[fieldName]
        if (field.defaultValue) {
          if (field.moduleFieldType.typeName === 'Boolean') {
            data[fieldName] = ['1', 'true'].includes(field.defaultValue)
          } else {
            data[fieldName] = field.defaultValue
          }
          // TODO - date field defaults here. like 'today', 'in x days' etc
        }
      })
    },

    updateLinkOptions () {
      Object.keys(this.module.fields).forEach((fieldName) => {
        let fieldInfo = this.module.fields[fieldName]
        if (['Link', 'MultiLink'].includes(fieldInfo.type)) {
          this.linkOptions[fieldName] = this.selectOptions(fieldName)
        }
      })
    },

    selectOptions (fieldName) {
      let linkModuleName = this.modules[this.moduleName].fields[fieldName].linkModule
      let linkModuleDisplayField = this.modules[this.moduleName].fields[fieldName].linkModuleDisplayField
      if (this.linkItems[linkModuleName]) {
        let multilingual = (linkModuleName && linkModuleDisplayField &&
          this.modules[linkModuleName] &&
          this.modules[linkModuleName].fields &&
          this.modules[linkModuleName].fields[linkModuleDisplayField] &&
          this.modules[linkModuleName].fields[linkModuleDisplayField].multilingual) || false
        return this.linkItems[linkModuleName].map((option) => {
          return {
            text: multilingual
              ? option[linkModuleDisplayField + '_' + this.language]
                ? option[linkModuleDisplayField + '_' + this.language]
                : option[linkModuleDisplayField + '_en']
              : option[linkModuleDisplayField],
            value: option._id,
            info: option
          }
        })
      }
      return []
    },

    /* openList () {
      this.$store.dispatch('getListItemsToStore', {
        moduleName: this.moduleName
      }).then((items) => {
      })
    }, */

    saveFormData () {
      // remove dynamc fields
      this.saving = true
      let filteredData = {}
      this.fieldsArrayFromModule.forEach(field => {
        if (field.fieldName in this.data &&
          !field.info.dynamic &&
          !['Virtual', 'Subtable'].includes(field.info.type)
        ) {
          filteredData[field.fieldName] = this.data[field.fieldName]
        }
        if (['Image', 'PrivateFile'].includes(field.info.type)) {
          if (this.data[field.fieldName + 'Name']) {
            filteredData[field.fieldName + 'Name'] = this.data[field.fieldName + 'Name']
            filteredData[field.fieldName + 'Extention'] = this.data[field.fieldName + 'Extention']
          }
        }
        if (field.info.multilingual) {
          // add all language options
          this.contentLanguages.forEach(lang => {
            let langFieldName = field.fieldName + '_' + lang.code
            if (langFieldName in this.data) {
              filteredData[langFieldName] = this.data[langFieldName]
            }
          })
        }
      })
      if (this.data._id) {
        filteredData._id = this.data._id
      }

      this.$store.dispatch('saveItem', {
        moduleName: this.moduleName,
        data: filteredData
      }).then(result => {
        this.saving = false
        this.lastSaveTimestamp = +new Date()
        setTimeout(() => {
          this.lastSaveTimestamp = 0
        }, 2500)
        if (result.data) {
          let data = result.data
          this.data = data
          this.formDataAtOpen = JSON.parse(JSON.stringify(data))
        }
        this.callbackOnChange(result._id || (result && result.message && result.message._id))
      })
    },

    startDeleteItem () {
      if (window.confirm('Delete for sure?')) {
        api.deleteItem(this.apiUrl, this.moduleName, this.id).then((result) => {
          if (result && !result.error) {
            // TODO - back to list?
            this.callbackOnChange(null)
            this.data = {}
          }
        })
      }
    },

    featureFields () {
      return this.fieldsArrayFromModule.filter(field => field.info.type === 'Features')
    },

    setDefaultValues () {
      if (this.parentId) {
        let singularParentObjectName = this.modules[this.parentModule].singular
        this.data[singularParentObjectName] = this.parentId
      }
      if (this.featureFields().length > 0) {
        this.featureFields().forEach(field => {
          if (!this.data[field.fieldName]) {
            this.data[field.fieldName] = {}
          }
        })
      }
    }
  }
}
</script>

<style>
.theme--light.v-application {
  background: white !important;
}
/* .container {
  padding: 0 !important;
}
.row {
  padding-right: 0 !important;
  padding-left: 0 !important;
} */
.th, .td {
  padding: 5px;
  margin: 10px;
}
.hide-tabs .v-tabs-bar {
  display: none;
}
.form-header-bar- {
  position: sticky;
  background: white;
  z-index: 6;
  width: 100%;
  top: 0;
}
.form-module-name {
  color: #aaa;
  font-size: 16px !important;
}
.form-title {
  color: #555;
  font-weight: 500;
  font-size: 20px !important;
}
.form-app-bar {
  position: sticky;
  top: 0;
  z-index: 6;
}
.dense-bar {
  font-weight: 300;
  font-size: 20px !important;
}
.form-title-selected {
  font-size: 20px;
  font-weight: 300;
}
@media only screen and (max-width: 959px) {
  .form-module-name {
    font-size: 12px !important;
  }
  .form-title {
    font-weight: normal;
    font-size: 16px !important;
  }
  .form-module-name-selected {
    font-size: 10px !important;
  }
  .form-title-selected {
    font-size: 22px !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 300;
  }
}
</style>
